// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"306d40c0","115":"204e46fb","163":"dfb76afa","319":"674f2e93","446":"4ff39456","453":"482a461e","578":"48531d0f","834":"307c911d"}[chunkId] + ".chunk.js";
};